import { useCallback } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { GApageViewShow } from '@/helpers/events-ga/page-views';
import { ICpageViewShow } from '@/helpers/events-intercom/page-views';
import useSendGAEvent from '@/hooks/ga/useSendGAEvent';
import useSendIntercomEvent from '@/hooks/intercom/useSendIntercomEvent';
import useChannelEvent from '@/hooks/events/useChannelEvent';
import { channelRecommendationTypes } from '@/config/events-keakie';
import { selectPreviousPath } from '@/state/selectors/routes';

const selector = (state) => ({ previousPath: selectPreviousPath(state) });

const useShowEvents = ({ showId, showTitle } = {}) => {
  const shouldSendPageViewEvents = !!showId && !!showTitle;

  // Page view event: GA
  useSendGAEvent({
    createEvent: useCallback(() => GApageViewShow({
      showId,
      showTitle
    }), [showId, showTitle]),
    shouldSend: shouldSendPageViewEvents
  });

  // Page view event: Intercom
  useSendIntercomEvent({
    createEvent: useCallback(() => ICpageViewShow({
      showId,
      showTitle
    }), [showId, showTitle]),
    shouldSend: shouldSendPageViewEvents
  });

  const { previousPath } = useSelector(selector, shallowEqual);

  // Send a channel view event when the user visits the page directly.
  // All other channel events are handled at the point the user attempts to go to the channel page
  useChannelEvent({
    channelId: showId,
    recommendationType: channelRecommendationTypes.DIRECT,
    recommendationId: null,
    shouldCall: !previousPath && showId // Only call this event if there is no previous path (it is a direct page visit)
  });
};

export default useShowEvents;